import { Pagination } from '@app/core/models/pagination';
import * as R from 'ramda';

export const defaultPagination: Pagination = {
  slicedStart: 1,
  slicedEnd: 1,
  slicedItemsIndexStart: 0,
  slicedItemsIndexEnd: 3,
  columnsNum: 1,
  activeNumber: 1,
  size: 1,
  offset: 2,
  slicedNumbers: [1],
  oneArrowLeft: false,
  doubleArrowLeft: false,
  oneArrowRight: false,
  doubleArrowRight: false,
  dotsLeft: false,
  dotsRight: false,
  itemsPerPage: 3,
  itemsLength: 0
};

export const calculatePagedItems = (activeNumber: number, itemsPerPage: number, items: any): any => {
  const from = R.multiply(activeNumber - 1, itemsPerPage);
  const to = R.multiply(activeNumber, itemsPerPage);
  return R.slice(from, to, items);
};

export const setPaginationSize = (itemsLength: number, itemsPerPage: number) => {
  let totalPages = 1;
  if (itemsLength > 0) {
    totalPages = R.divide(itemsLength, itemsPerPage);
  }
  totalPages = Math.ceil(totalPages);

  return totalPages;
};

export const setSlicedNumbers = (slicedStart, slicedEnd) => {
  let slicedNumbers = [];
  if (slicedEnd < slicedStart) {
    slicedNumbers = [1];
  } else {
    for (let i = slicedStart; i <= slicedEnd; i++) {
      slicedNumbers = [...slicedNumbers, i];
    }
  }
  return slicedNumbers;
};

export const calculateItemsPerPageByColumnNum = (columnsNum, itemsPerPage) => {
  let newItemsPerPageNum;
  for (let i = itemsPerPage; i < columnsNum + itemsPerPage; i++) {
    if (i % columnsNum === 0) {
      return newItemsPerPageNum = +i;
    }
  }
  return newItemsPerPageNum;
};

export const validatePaginationProps = paginationProps => {
  const {itemsLength, itemsPerPage, activeNumber, offset, size} = paginationProps;

  if (itemsPerPage < 2) {
    paginationProps.itemsPerPage = 2;
  }
  if (itemsLength < 0) {
    paginationProps.itemsLength = 0;
  }
  if ((size.length < activeNumber)
    || activeNumber < 1) {
    paginationProps.activeNumber = 1;
  }
  if (offset < 1) {
    paginationProps.offset = 1;
  }
};

export const preparePagination = paginationProps => {
  if (!paginationProps) {
    paginationProps = {} as Pagination;
  } else {
    validatePaginationProps(paginationProps);
  }

  const {itemsLength = 0, activeNumber = 1, offset = 2, itemsPerPage = 3, columnsNum} = paginationProps;

  let itemsPerPageNew;
  if (columnsNum && (itemsPerPage % columnsNum !== 0)) {
    itemsPerPageNew = calculateItemsPerPageByColumnNum(columnsNum, itemsPerPage);
  } else {
    itemsPerPageNew = itemsPerPage;
  }

  const size = setPaginationSize(itemsLength, itemsPerPageNew);
  const slicedStart = activeNumber - offset > 1 ?
    (activeNumber - offset) : 1;
  const slicedEnd = activeNumber + offset > size ?
    size : (activeNumber + offset);
  const slicedItemsIndexStart = R.multiply(activeNumber - 1, itemsPerPageNew);
  const slicedItemsIndexEnd = +R.multiply(activeNumber, itemsPerPageNew);

  return {
    size,
    slicedStart,
    slicedEnd,
    slicedItemsIndexStart,
    slicedItemsIndexEnd,
    columnsNum: columnsNum || 1,
    slicedNumbers: setSlicedNumbers(slicedStart, slicedEnd),
    oneArrowLeft: activeNumber > 1,
    doubleArrowLeft: activeNumber > 1,
    oneArrowRight: activeNumber < size,
    doubleArrowRight: activeNumber < size,
    dotsLeft: slicedStart > 1,
    dotsRight: slicedEnd < size,
    itemsPerPage: itemsPerPageNew,
    itemsLength,
    activeNumber,
    offset
  } as Pagination;
};

